export default __webpack_public_path__ + "static/sylvia-fee49bb110fc57255960627bb2161d9a.jpeg";